// @ts-nocheck
import { OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ orderLine: OrderLineModel | null }>;

export const dispatchSetNewOrderLines: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/OrderComplaint/SetOrderLines",
        orderLine: props.parameter.orderLine,
    });
};

export const chain = [dispatchSetNewOrderLines];

const setNewOrderLines = createHandlerChainRunner(chain, "SetNewOrderLines");
export default setNewOrderLines;
